import { render, staticRenderFns } from "./ModalErrorConnecting.vue?vue&type=template&id=2bcd8d1b&"
import script from "./ModalErrorConnecting.vue?vue&type=script&lang=js&"
export * from "./ModalErrorConnecting.vue?vue&type=script&lang=js&"
import style0 from "./ModalErrorConnecting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports